<div class="flex flex-row h-full bg-white overflow-hidden">
  <div class="grow overflow-hidden">
    @let firstLevelLink = route() && !children();

    <div
      [class.pb-2]="children()"
      [class.py-2]="!children()"
      [class.cursor-pointer]="firstLevelLink"
      [routerLink]="firstLevelLink ? route().routerLink : null"
      [queryParams]="firstLevelLink ? route().queryParams : null"
      class="group flex-col rounded-xl pl-4 text-neutral-800 has-[.active]:bg-blue-50 [:not(:has(:is(.active,.child)))_&]:hover:bg-neutral-50"
    >
      @if (route()) {
        <div class="flex flex-row gap-x-2 h-full items-center">
          @if (icon()) {
            <div class="flex justify-center items-center rounded-xl text-neutral-500">
              <ng-container *ngTemplateOutlet="iconTemplate" />
            </div>
          }

          <a
            [routerLinkActiveOptions]="{ exact: route()?.exactRouteMatch || false }"
            [attr.data-testId]="'menu-item-' + name().trim().toLowerCase().replaceAll(' ', '-')"
            class="flex grow items-center text-sm/6 font-semibold"
            routerLinkActive="text-blue-500 active"
            >{{ name() }}</a
          >
        </div>
      }

      @if (children()) {
        <div
          class="child flex items-center justify-between py-2 font-semibold"
          tabindex="0"
        >
          <div class="flex flex-row gap-x-2 h-full items-center">
            <div
              class="flex justify-center items-center rounded-xl text-neutral-300 group-has-[.active]:bg-blue-50"
            >
              @if (icon()) {
                <ng-container *ngTemplateOutlet="iconTemplate" />
              }
            </div>
            <span
              [attr.data-testId]="`menu-item-${name().trim().toLowerCase().replaceAll(' ', '-')}`"
              class="text-sm/6"
              >{{ name() }}</span
            >
          </div>
        </div>

        <div class="flex flex-col gap-0.5 ml-6">
          @for (child of children(); track child.name) {
            @if (child.visible) {
              <ng-container *ngTemplateOutlet="childTemplate; context: { $implicit: child }" />
            }
          }
        </div>
      }
    </div>
  </div>
</div>

<ng-template
  #childTemplate
  let-child
>
  <div
    [routerLink]="child.route.routerLink"
    [queryParams]="child.route.queryParams"
    class="flex items-center justify-between py-1 pl-2 pr-4 text-xs/5 rounded-xl has-[.active-child]:bg-blue-50 hover:bg-neutral-50 cursor-pointer"
  >
    <a
      [routerLinkActiveOptions]="{ exact: route()?.exactRouteMatch || false }"
      [attr.data-testId]="'menu-item-' + child.name.trim().toLowerCase().replaceAll(' ', '-')"
      class="truncate"
      routerLinkActive="font-bold text-blue-500 active-child"
      >{{ child.name }}</a
    >
  </div>
</ng-template>

<ng-template #iconTemplate>
  @if (useCustomIcon()) {
    <flx-icon
      [name]="icon()"
      [routerLinkActiveOptions]="{ exact: route()?.exactRouteMatch || false }"
      class="w-6 h-6 group-has-[.active]:text-blue-500"
      routerLinkActive="active"
    />
  } @else {
    <i
      [class]="icon()"
      [routerLinkActiveOptions]="{ exact: route()?.exactRouteMatch || false }"
      class="text-2xl/6 text-neutral-500 group-has-[.active]:text-blue-500"
      routerLinkActive="active"
    ></i>
  }
</ng-template>
